import { Observable } from 'rxjs';

export interface GridCalendar {
    months?: Month[];
    readonly minimumTimestamp: number;
    readonly maximumTimestamp: number;
}

export class Month {
    readonly days: Day[];
    readonly year: number;
    readonly monthId: number;
    readonly monthOfYear: string;

    constructor( days: Day[], monthId: number, year: number, monthOfYear: string ) {
        this.days = days;
        this.monthId = monthId;
        this.year = year;
        this.monthOfYear = monthOfYear;
    }
}

export interface Day {
    readonly dayId: number;
    readonly dayOfWeek: string;
    readonly dayAttributes: DayAttribute[];
    readonly events: Event[];
    readonly isToday: boolean;
    isSelected: boolean;
}

export interface Event {
    readonly identifier: string;
    readonly css: string;
    readonly abbreviation: string;
    readonly description: string;
}

export class DayAttribute {
    readonly identifier: string;
    readonly css: string;
    readonly abbreviation: string;
    readonly description: string;
    readonly mustBeDisplayed?: boolean;

    constructor( identifier: string, css: string, abbreviation: string, description: string, mustBeDisplayed?: boolean ) {
        this.identifier = identifier;
        this.css = css;
        this.abbreviation = abbreviation;
        this.description = description;
        this.mustBeDisplayed = mustBeDisplayed;
    }
}

// static attributes
export const DAY_ATTRIBUTE_SELECTED_DAY = new DayAttribute( 'SELECTED_DAY', 'selectedDayOverlay', 'cs.sys.hisng.gridcalendar.dayattribute.selectedDay.abbreviation', 'cs.sys.hisng.gridcalendar.dayattribute.selectedDay' );
export const DAY_ATTRIBUTE_CURRENT_DAY = new DayAttribute( 'CURRENT_DAY', 'currentDayOverlay', 'cs.sys.hisng.gridcalendar.dayattribute.currentDay.abbreviation', 'cs.sys.hisng.gridcalendar.dayattribute.currentDay' );

// date with day of week fields - german date format
export const GERMAN_DATE_WITH_DAYOFWEEK_PIPE_FORMAT = 'EEEE, d. MMMM yyyy';
// date with day of week fields - english date format
export const ENGLISH_DATE_WITH_DAYOFWEEK_PIPE_FORMAT = 'EEEE, MMMM d, yyyy';

// must be implemented by the calling component or service to load calendar data
export interface GridCalendarDataProvider {
    getGridCalendarData( firstMonth: Month | null, lastMonth: Month | null ): Observable<GridCalendar>;
}

// must be implemented by the calling component or service to load calendar legend data
export interface GridCalendarLegendDataProvider {
    getGridCalendarLegendData( firstMonth: Month | null, lastMonth: Month | null ): Observable<( Event | DayAttribute )[]>;
}
